import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import SuperadminNavbar from './SuperadminNavbar'

const SuperadminDashboard = () => {
  return (
    <Box
      className='App'
      sx={{
        minHeight: '100vh',
        background: '#F4F7FA',
        color: '#0F1B2A',
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
      }}
    >
        <SuperadminNavbar />
        <Box
          sx={{
            px: { xs: 2, sm: 3, md: 4 },
            pt: { xs: 2, md: 3 },
            pb: 4,
            maxWidth: 1400,
            mx: 'auto',
            boxSizing: 'border-box',
          }}
        >
        <Outlet />
        </Box>
    </Box>
  )
}

export default SuperadminDashboard
